<footer class="footer">
  <div class="container-footer text-center">
    <a
      class="cc-facebook btn btn-link"
      href="https://www.instagram.com/_vikas_me/"
      target="_blank"
      rel="tooltip"
      title="Follow me on Instagram"
    >
      <i class="fa fa-instagram" aria-hidden="true"></i>
    </a>
    <a
      class="cc-linkedin btn btn-link"
      href="https://www.linkedin.com/in/vikas-2jan/"
      target="_blank"
      rel="tooltip"
      title="Follow me on Linkedin"
    >
      <i class="fa fa-linkedin" aria-hidden="true"></i>
    </a>
  </div>
  <div class="text-center text-muted">
    <p>&copy; All rights reserved.</p>
  </div>
</footer>
